define('datakit/mixin/fetched.flag.mixin',['require','exports','module'],function(require, exports, module) {

  var FetchedFlagMixin = {

    initializeMixin: function() {
      this.fetched = false;
      this.once('sync', function() {
        this.fetched = true;
      }, this);
    }

  };

  module.exports = FetchedFlagMixin;
});

